module.exports = __webpack_public_path__ + "acb296885f95ab31d65e0bef3a7227c9.svg";